import { DEFAULT_LICENSE } from '../constants';

export const normalizeLicense = (license?: string | null) =>
  license?.trim().toUpperCase() ?? '';

export interface IContentByLicense {
  id: number;
  license: string;
  text: string;
}

export interface IWithContentByLicense {
  contentByLicense?: IContentByLicense[];
}

const findByLicense = (
  contentByLicense: IContentByLicense[],
  license?: string | null
) => {
  const targetLicense = normalizeLicense(license);
  if (!targetLicense) return;

  return contentByLicense.find(
    (item) => normalizeLicense(item.license) === targetLicense
  );
};

export const getContentByLicense = (
  contentByLicense: IContentByLicense[] = [],
  license?: string | null
) =>
  (
    findByLicense(contentByLicense, license) ??
    findByLicense(contentByLicense, DEFAULT_LICENSE)
  )?.text ?? '';
